import React from 'react';
import { useAPIContext } from '../../../../frontend-brands/src/context/api';
import { BrandsAPI } from '../../../../constructs/brands/interface';

export const useDeleteBanner = () => {
  const { callEndpoint } = useAPIContext();

  const deleteBanner = React.useCallback(
    async (bannerId: string) => {
      try {
        if (!bannerId) throw new Error('bannerId es requerido');

        const res = await callEndpoint<BrandsAPI, 'delete-banner'>('brands', `/banners/${bannerId}`, 'DELETE');

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res; // { success: true, bannerId }
      } catch (error: any) {
        console.error('Error al eliminar el banner:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { deleteBanner };
};
